module.exports = __webpack_public_path__ + "static/media/laptop1.87561258.jpg";